export interface ModelResultDonationPayload {
  id?: number;
  modelDetailedResult?: number;
  incomeDonations?: number;
  recurringAmount?: number;
  nonRecurringAmount?: number;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function extractId(input: any, field: string): number | undefined {
  const direct = toNumber(input?.[field]);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.[field]?.id);
}

export function buildModelResultDonationPayload(input: any): ModelResultDonationPayload {
  const payload: ModelResultDonationPayload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const modelDetailedResult = extractId(input, 'modelDetailedResult');
  if (modelDetailedResult !== undefined) payload.modelDetailedResult = modelDetailedResult;

  const incomeDonations = extractId(input, 'incomeDonations');
  if (incomeDonations !== undefined) payload.incomeDonations = incomeDonations;

  const recurringAmount = toNumber(input?.recurringAmount);
  if (recurringAmount !== undefined) payload.recurringAmount = recurringAmount;

  const nonRecurringAmount = toNumber(input?.nonRecurringAmount);
  if (nonRecurringAmount !== undefined) payload.nonRecurringAmount = nonRecurringAmount;

  return payload;
}
